import type { Tag as TagType } from 'models';
import { Col, Row, Space, Tag, Text } from 'ui';

type P = {
  tags: TagType[];
};

const ChannelsDetailTags = ({ tags }: P) => (
  <Row align="middle" gutter={['ms', 'xs']}>
    <Col span={24}>
      <Text size="small" type="title" uppercase weight="medium">
        Tags
      </Text>
    </Col>
    <Col>
      <Space size="small" wrap>
        {tags.map((tag) => (
          <Tag key={tag.id}>{tag.name}</Tag>
        ))}
      </Space>
    </Col>
  </Row>
);

export default ChannelsDetailTags;
